import styled from "styled-components";
const WheelDiv = styled.div`
    overflow-y: auto;
    & > ul {
      position: relative;
      margin: 0;
      display: inline-block;
      list-style: none;
      overflow-y: scroll;
      will-change: transform;
      overflow-x: hidden;
      text-align: center;
      padding: 0 5px;
      height: 150px;
      background-color: #fff;
      box-shadow: 1px 3px 10px #fff inset;
      -ms-overflow-style: none;
      scrollbar-width: none; 
      
      & > li {
        align-items: center;
        width: 100%;
        background-image: none;
        padding: 0;
      }
      & > li[aria-selected="true"] {
        background-color: #eeeeef;
      }
      & > li > span {
        display: none;
      }
      & > li > p {
        text-align: center;
        margin: 0 5px;
        width: 100%;
        padding: 0
      }
      &::-webkit-scrollbar {
        display: none;
      }
      &:focus {
        outline: none;
      }
    }
  `;
export { WheelDiv };
